import React, { useEffect, useState } from "react";
import Text from "@amzn/meridian/text";
import { Tag } from "@amzn/meridian";
import { formatTimeRemaining } from "src/utils/dateUtil";

const COUNTDOWN_TICK_MS = 1000;

interface DraftExpiryFooterProps {
  /** Unix epoch SECONDS when the in-progress draft auto-clears server-side. */
  expiresAt: number;
}

/**
 * Home-card footer for an in-progress, unexpired draft: a warning "In Progress"
 * tag plus a live "Expires in …" countdown that ticks every second, falling back
 * to "Expired" if the TTL elapses before the list refreshes. Shared by the Recent
 * Inspection card and the scheduled-inspection card so a resumable inspection
 * reads the same in both sections.
 */
const DraftExpiryFooter: React.FC<DraftExpiryFooterProps> = ({ expiresAt }) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), COUNTDOWN_TICK_MS);
    return () => clearInterval(timer);
  }, [expiresAt]);

  const timeRemaining = formatTimeRemaining(expiresAt, now);

  return (
    <>
      <Tag type="warning">In Progress</Tag>
      <Text type="b100" color="secondary">
        {timeRemaining ? `Expires in ${timeRemaining}` : "Expired"}
      </Text>
    </>
  );
};

export default DraftExpiryFooter;
